import { createIconDefinition } from '../../../../cross-team-shared/icons/create-icon-definition';

export const viewNoneIcon = createIconDefinition(
  'viewNoneIcon',
  `<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
<path d="M16.9121 1.91113L1.91211 16.9111L3.09062 18.0896L18.0906 3.08964L16.9121 1.91113Z"/>
<path d="M4.16797 2.50033H14.5846L12.918 4.16699H4.16797V6.94477H10.1402L8.47352 8.61144H4.16797V11.3892H5.69575L2.5013 14.5837V4.16699C2.5013 3.24652 3.24749 2.50033 4.16797 2.50033Z"/>
<path d="M15.8346 11.3892H11.5883L9.92164 13.0559H15.8346V15.8337H7.14386L5.47719 17.5003H15.8346C16.7551 17.5003 17.5013 16.7541 17.5013 15.8337V5.47622L14.3661 8.61144H15.8346V11.3892Z"/>
</svg>`,
);
